import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialFreeTrialDecisionState = {
    displayByUserAction: false,
    displayByCTA: false,
    failLimitReason: '',
};
const initialSaveToCrmState = {
    isOpen: false,
    options: null,
};
const initialContactTagsState = {
    isOpen: false,
    position: 'plugin_tag',
};
const initialUpgradePlanState = {
    isOpen: false,
    source: null,
};
const initialState = {
    freeTrialDecision: initialFreeTrialDecisionState,
    saveToCrm: initialSaveToCrmState,
    contactTags: initialContactTagsState,
    isCrmUpdateAnnouncementOpen: false,
    upgradePlan: initialUpgradePlanState,
};
const slice = createSlice({
    name: 'POPUPS',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        showFreeTrialDecisionPopup(state, { payload }) {
            state.freeTrialDecision.displayByUserAction = true;
            state.freeTrialDecision.failLimitReason = payload || '';
        },
        hideFreeTrialDecisionPopup(state) {
            state.freeTrialDecision = initialFreeTrialDecisionState;
        },
        setFreeTrialDecisionDisplayByCTA(state, { payload }) {
            state.freeTrialDecision.displayByCTA = payload;
        },
        showSaveToCrmPopup(state, { payload }) {
            state.saveToCrm.isOpen = true;
            state.saveToCrm.options = payload;
        },
        hideSaveToCrmPopup(state) {
            state.saveToCrm = initialSaveToCrmState;
        },
        showContactTagsPopup(state, { payload }) {
            state.contactTags.isOpen = true;
            state.contactTags.position = payload;
        },
        hideContactTagsPopup(state) {
            state.contactTags = initialContactTagsState;
        },
        showCrmUpdateAnnouncement(state) {
            state.isCrmUpdateAnnouncementOpen = true;
        },
        hideCrmUpdateAnnouncement(state) {
            state.isCrmUpdateAnnouncementOpen = false;
        },
        showUpgradePlanPopup(state, { payload }) {
            state.upgradePlan.isOpen = true;
            state.upgradePlan.source = payload;
        },
        /** Keeps `source` so analytics fired while the modal animates out still carry it. */
        hideUpgradePlanPopup(state) {
            state.upgradePlan.isOpen = false;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
